import React from "react";
import { ArrowUpRight } from "lucide-react";

export default class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Studio map failed to render:", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="border border-[#E2E0D8] bg-[#FAFAFA] p-8 lg:p-12">
        <p className="mono text-[9px] text-[#8C7862] mb-6">[ STUDIO LOCATIONS ]</p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <h3 className="display text-[24px] text-[#141414]">HRD Mimarlık</h3>
            <p className="text-[14px] text-[#141414]/70 mt-3 leading-relaxed">
              Perpa Ticaret Merkezi B Blok, Kat: 11 No: 1719
              <br />
              Okmeydanı — İstanbul / Turkiye
            </p>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=41.06067,28.97024"
              target="_blank"
              rel="noopener noreferrer"
              className="mono text-[9px] text-[#141414] mt-4 inline-flex items-center gap-1.5 link-underline"
            >
              [ GET DIRECTIONS <ArrowUpRight size={11} strokeWidth={1.9} /> ]
            </a>
          </div>
          <div>
            <h3 className="display text-[24px] text-[#141414]">
              HRD Architecture / Keiki Concept Oy
            </h3>
            <p className="text-[14px] text-[#141414]/70 mt-3 leading-relaxed">
              Maisalantie 2 b
              <br />
              Helsinki, Finland
            </p>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=60.62667,25.29533"
              target="_blank"
              rel="noopener noreferrer"
              className="mono text-[9px] text-[#141414] mt-4 inline-flex items-center gap-1.5 link-underline"
            >
              [ GET DIRECTIONS <ArrowUpRight size={11} strokeWidth={1.9} /> ]
            </a>
          </div>
        </div>
        <p className="mono text-[8.5px] text-[#A8A29A] mt-8">
          Interactive map temporarily unavailable — addresses above are always up to date.
        </p>
      </div>
    );
  }
}
